<template>
  <div class="wait-for-start">Waiting for host to start the game</div>
</template>

<style scoped>
.wait-for-start {
  text-align: center;
}
</style>
